<template>
  <PageWrapper>
    <template #title> ارسال نوتیفیکیشن جدید </template>
    <SendNotification></SendNotification>
  </PageWrapper>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
    };
  },
  components: {
    SendNotification,
    PageWrapper,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SendNotification from "@/views/components/Notifications/SendNotification.vue";
</script>
